import type { IconData } from '@stacksjs/iconify-core'

export const wikipedia: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M19.857.021h-3.982v.687h.398c.311 0 .592.161.751.431a.88.88 0 0 1 .016.872l-4.283 7.93l-1.95-4.69l1.836-3.402A2.17 2.17 0 0 1 14.548.708h.217V.02h-4.112v.688h.398c.311 0 .592.161.75.431a.88.88 0 0 1 .017.872l-1.333 2.467l-1.188-2.856a.65.65 0 0 1 .059-.62A.64.64 0 0 1 9.9.708h.435V.02H5.467v.688h.194c.909 0 1.723.546 2.074 1.391L9.49 6.32L7.535 9.942l-3.46-8.32a.65.65 0 0 1 .059-.62a.64.64 0 0 1 .544-.294h.598V.02H0v.688h.439c.908 0 1.723.546 2.074 1.391l3.988 9.591a.446.446 0 0 0 .804.042l.52-.964l1.986-3.676l1.912 4.598a.446.446 0 0 0 .804.041l.52-.963l4.819-8.92A2.17 2.17 0 0 1 19.77.709h.217V.02z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default wikipedia
